import { ReactComponent as AfrySvg } from './Afry.svg';


const Afry = () => (
    <div className="companyName">
    <AfrySvg/>

    </div>
)

export default Afry;

